import users from '@/modules/user/users/store';
import auth0Users from '@/modules/user/auth0/store';
import rfid from '@/modules/user/rfid/store';
import consumers from '@/modules/user/consumers/store';
import notifications from '@/modules/user/notifications/store';

export default {
  modules: [users, auth0Users, rfid, consumers, notifications],
};
